import React from "react";
import {
  LuAlertTriangle,
  LuArrowLeft,
  LuCheck,
  LuClub,
  LuDiamond,
  LuHeart,
  LuClock,
  LuCopy,
  LuCrown,
  LuFlagTriangleRight,
  LuInfo,
  LuLayers,
  LuLoader2,
  LuLock,
  LuLogIn,
  LuLogOut,
  LuMedal,
  LuMessageCircle,
  LuPalette,
  LuPencil,
  LuPlay,
  LuPlus,
  LuQrCode,
  LuSave,
  LuSearch,
  LuSend,
  LuShare2,
  LuSkipForward,
  LuSkull,
  LuSlidersHorizontal,
  LuSparkles,
  LuSpade,
  LuStar,
  LuTimer,
  LuTrash2,
  LuTrophy,
  LuUserX,
  LuUsers,
  LuVolume2,
  LuVolumeX,
  LuVote,
  LuX,
} from "react-icons/lu";

// Semantic name → Lucide glyph. Components may only use these names, so the
// icon set can be swapped in this one file (DESIGN_SYSTEM.md → Icons).
const ICONS = {
  alert: LuAlertTriangle,
  back: LuArrowLeft,
  cards: LuLayers,
  check: LuCheck,
  chat: LuMessageCircle,
  clock: LuTimer,
  close: LuX,
  color: LuPalette,
  copy: LuCopy,
  create: LuPlus,
  crown: LuCrown,
  delete: LuTrash2,
  edit: LuPencil,
  end: LuFlagTriangleRight,
  enter: LuLogIn,
  heavy: LuSkull,
  info: LuInfo,
  leave: LuLogOut,
  loading: LuLoader2,
  lock: LuLock,
  medal: LuMedal,
  next: LuSkipForward,
  offline: LuUserX,
  play: LuPlay,
  qr: LuQrCode,
  save: LuSave,
  search: LuSearch,
  send: LuSend,
  settings: LuSlidersHorizontal,
  share: LuShare2,
  sparkles: LuSparkles,
  soundOff: LuVolumeX,
  soundOn: LuVolume2,
  spade: LuSpade,
  suitClub: LuClub,
  suitDiamond: LuDiamond,
  suitHeart: LuHeart,
  time: LuClock,
  trophy: LuTrophy,
  users: LuUsers,
  vote: LuVote,
  wrong: LuX,
  you: LuStar,
};

export type IconName = keyof typeof ICONS;

type IconProps = {
  name: IconName;
  size?: number;
  strokeWidth?: number;
  label?: string;
  className?: string;
  color?: string;
};

const Icon: React.FC<IconProps> = ({
  name,
  size = 20,
  strokeWidth = 2.5,
  label,
  className,
  color,
}) => {
  const Glyph = ICONS[name];
  return (
    <Glyph
      size={size}
      strokeWidth={strokeWidth}
      color={color}
      className={className}
      aria-hidden={label ? undefined : true}
      aria-label={label}
      role={label ? "img" : undefined}
      style={
        name === "loading"
          ? { animation: "spin 900ms linear infinite", flexShrink: 0 }
          : { flexShrink: 0 }
      }
    />
  );
};

export default Icon;
